export default __webpack_public_path__ + "static/media/icon-dollar.9f9be353.svg";